import { cn } from "@/lib/utils";

type VersionProps = {
  className?: string;
};
export function Version({ className }: VersionProps) {
  return (
    <p
      className={cn(
        "m-4 text-center text-xs text-muted-foreground/30",
        className,
      )}
    >
      ClassView {APP_VERSION}
    </p>
  );
}
